import { apiClient } from '@/lib/api/client';

export async function getHomeInfo(config) {
    return apiClient.get('/home', config);
}

export const homeApi = {
    homeInfo: getHomeInfo,
};
export default homeApi;